import { z } from 'zod';

const checkListItems = (value, context, t, propSubName) => {
  const errors = [];
  Object.keys(value).forEach((propName) => {
    const property = value[propName];
    if (property?.items) {
      if (
        !property.items.propertiesConfig ||
        Object.keys(property.items.propertiesConfig).length === 0
      ) {
        context.addIssue({
          expected: 'property',
          code: 'one_property',
          path: propSubName
            ? [propName, propSubName, 'items', 'propertiesConfig']
            : [propName, 'items'],
          message: t('ContentTypeForm.Errors.OneProperty'),
        });
      } else {
        checkListItems(property.items.propertiesConfig, context, t, propName);
      }
    }
  });
  return errors;
};

export const generateZodSchema = (t) =>
  z.object({
    label: z
      .string()
      .min(1, t('Form.FormErrorNotBlank'))
      .refine(
        (value) => value?.[0] !== '/',
        t('Form.FormErrorNotStartWithSlash'),
      )
      .refine(
        (value) => (value?.match(/\//g) || []).length <= 1,
        t('Form.FormErrorNoMoreThanOneSlash'),
      ),
    name: z.string(),
    draftPublic: z.boolean().optional(),
    metaDefinition: z.object({
      propertiesConfig: z.object({}).superRefine((value, ctx) => {
        checkListItems(value, ctx, t);
      }),
    }),
  });
